// billing-plugin/common/schemas/collections/servicePacks.js
import { z } from "zod";
import { PlanFeatureLinkSchema } from "./billingPlans.js";

const ServicePackSchema = z.object({
    _id: z.string().optional(),
    packId: z.string().describe("Unique, human-readable ID, e.g., 'extra-api-calls-10k'."),
    name: z.string().min(1, "Pack name is required."),
    description: z.string().optional(),
    currency: z.string().length(3),
    oneTimeCost: z.number().int().default(0),
    recurringCost: z.number().int().default(0),
    lineItems: z.array(PlanFeatureLinkSchema),
    isPublic: z.boolean().default(true),
    isArchived: z.boolean().default(false).describe("Archived packs are hidden and cannot be added to subscriptions."), // NEW
    metadata: z.record(z.any()).optional(),
    createdAt: z.coerce.date().optional(),
    updatedAt: z.coerce.date().optional(),
});

export default ServicePackSchema;